function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_58119_56130)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.5 1.5C0.776142 1.5 1 1.72386 1 2V4.5H3.5C3.77614 4.5 4 4.72386 4 5C4 5.27614 3.77614 5.5 3.5 5.5H0.5C0.223858 5.5 0 5.27614 0 5V2C0 1.72386 0.223858 1.5 0.5 1.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.30268 1.05268C6.37614 0.901648 7.4696 1.10358 8.41832 1.62804C9.36704 2.1525 10.1196 2.97108 10.5626 3.96045C11.0057 4.94981 11.1152 6.05636 10.8746 7.11337C10.6341 8.17038 10.0566 9.12058 9.22904 9.82081C8.40151 10.521 7.36883 10.9334 6.28659 10.9957C5.20435 11.0579 4.13118 10.7668 3.22878 10.1662C2.32638 9.56549 1.64363 8.68782 1.28341 7.66539C1.19165 7.40494 1.3284 7.11942 1.58885 7.02766C1.8493 6.93589 2.13483 7.07264 2.22659 7.3331C2.51476 8.15104 3.06096 8.85318 3.78288 9.33371C4.5048 9.81424 5.36334 10.0471 6.22913 9.9973C7.09492 9.94747 7.92107 9.61762 8.58309 9.05743C9.24511 8.49725 9.70715 7.73708 9.89958 6.89148C10.092 6.04587 10.0044 5.16063 9.64998 4.36914C9.29555 3.57765 8.69349 2.92278 7.93452 2.50321C7.17554 2.08364 6.30077 1.9221 5.442 2.04292C4.58323 2.16375 3.78699 2.56039 3.17326 3.17309C3.16969 3.17666 3.16606 3.18017 3.16239 3.18362L0.84239 5.36362C0.64115 5.55272 0.324721 5.54287 0.135625 5.34163C-0.0534708 5.14039 -0.0436264 4.82396 0.157613 4.63487L2.47225 2.45991C3.23867 1.69715 4.23178 1.20335 5.30268 1.05268Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_58119_56130"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white"
})));

var SvgReview = function SvgReview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/review.b2588b4a.svg";
export { ForwardRef as ReactComponent };